import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import lawyerIcon from '../../assets/images/lawyer.png'
import agentIcon from '../../assets/images/agent.png'
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
//import Lead from "./Lead";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,

  Modal,
  CardImg,
  CardFooter,
  CardHeader
} from "reactstrap"
import { API_URL } from "helpers/api_url";
import axios from "axios";
import TitleDropdowns from "components/dropdowns/titleDropdowns";

class MyLawyer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      
    }
    this.toggleRightCanvasLawyer = this.toggleRightCanvasLawyer.bind(this);
    this.toggleRightCanvasAgent = this.toggleRightCanvasAgent.bind(this);
    this.handleSubmitLowyer =   this.handleSubmitLowyer.bind(this);
    this.handleSubmitMortgage = this.handleSubmitMortgage.bind(this);
    
  }

  toggleRightCanvasLawyer() {
    this.setState({ isRightLawyer: !this.state.isRightLawyer });
  }

  
  toggleRightCanvasAgent() {
    this.setState({ isRightAgent: !this.state.isRightAgent });
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        console.log(modifiedAddress)
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  handleSubmitLowyer = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
      
          dealId: values.dealId,
          professionalContactTypeId: values.professionalContactTypeId,
          contactFName: values.contactFName,
          contactLName: values.contactLName,
          contactName: `${values.contactFName} ${values.contactLName}`,
          clientId: parseInt(values.clientId),
          agentId: parseInt(values.agentId),
          organizationName: values.organizationName,
          email: values.email,
          phone: values.phone,
          mobile: values.mobile,
         
          fullAddress:values.fullAddress,
          addressLine1:values.addressLine1,
          addressLine2:values.addressLine2,
          nearestIntersection:values.nearestIntersection,
          city:values.city,
          province:values.province,
          postal:values.postal,
          country:values.country,
          longitude:values.longitude,
          latitude:values.latitude,   
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const response = await axios.post(
       `${API_URL}ClientProfessionalContactExt/add_client_legal_contact`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, 
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
      
        this.toggleRightCanvasLawyer();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      
    } finally {
      setSubmitting(false);
    }
  };
  handleSubmitMortgage = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
      
          dealId: values.dealId,
          professionalContactTypeId: values.professionalContactTypeId,
          contactFName: values.contactFName,
          contactLName: values.contactLName,
          contactName: `${values.contactFName} ${values.contactLName}`,
          clientId: parseInt(values.clientId),
          agentId: parseInt(values.agentId),
          organizationName: values.organizationName,
          email: values.email,
          phone: values.phone,
          mobile: values.mobile,
         
          fullAddress:values.fullAddress,
          addressLine1:values.addressLine1,
          addressLine2:values.addressLine2,
          nearestIntersection:values.nearestIntersection,
          city:values.city,
          province:values.province,
          postal:values.postal,
          country:values.country,
          longitude:values.longitude,
          latitude:values.latitude,   
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const response = await axios.post(
       `${API_URL}ClientProfessionalContactExt/add_client_mortgage_contact`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, 
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
      
        this.toggleRightCanvasAgent();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      
    } finally {
      setSubmitting(false);
    }
  };
  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Legal Contacts  | Realty Space</title>
          </MetaTags>
          <Container fluid>
             <Breadcrumbs
              title={this.props.t("Settings")}
              breadcrumbItem={this.props.t("Legal Contacts")}
              heading={this.props.t("Set your professional team")}
            />
            {/* <h1>Set your professional team</h1> */}
            <Row>
              <Col xl="12">
              <Row>
                    <Col sm="12">
                      <Card className="mini-stats-wid" style={{backgroundColor:'#eff7ff',fontFamily:'Helvetica '}}> 
                        <CardBody>
                          <CardTitle>Welcome to our Share Your Contacts page!</CardTitle>
                          <p style={{fontFamily:'Helvetica '}}>
                          Here you can securely provide your lawyer and Mortgage broker details with me. This allows me quick access to your trusted professionals.<br/><br/>
                          let&apos;s simplify the process and ensure everyone is on the same page for a smooth home buying or selling experience
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                </Row>

                <Card className="mini-stats-wid"> 
                    <CardBody>
                      <Row className="mb-5">
                        <Col sm='2'></Col>
                        <Col sm='4'>
                        <Link onClick={this.toggleRightCanvasLawyer} to="#">
                    <Card className="me-2">

                      <CardImg src={lawyerIcon} className="px-5 py-3 mb-4" style={{border: '4px solid #dadee3'}}/>
                      <CardFooter className="mt-0 text-center" style={{background:'#28b5bd'}}><h3 style={{color:'white'}}>Set Your Real State Lawyer Info</h3></CardFooter>
                    </Card>
                    </Link>
                        </Col>
                        <Col sm='4'>
                        <Link onClick={this.toggleRightCanvasAgent} to="#">
                    <Card className="me-2">
                      <CardImg src={agentIcon} className="px-5 py-3 mb-4" style={{border: '4px solid #dadee3'}}/>
                      <CardFooter className="mt-0 text-center" style={{background:'#d56dce'}}><h3 style={{color:'white'}}>Set Your Mortgage Agent Info</h3></CardFooter>
                    </Card>
                    </Link>
                        </Col>
                        </Row>
                        <Row className="mb-5"></Row>
                    </CardBody>
                  </Card>
            </Col>
            
            </Row>
                    <Offcanvas
                      isOpen={this.state.isRightLawyer}
                      direction="end"
                      toggle={this.toggleRightCanvasLawyer}
                      style={{width:800}}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvasLawyer}>
                        My Lawyer
                      </OffcanvasHeader>
                      <OffcanvasBody>
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          dealId: 0,
                          professionalContactTypeId: 1,
                          contactFName: (this.state && this.state.contactFName) || "",
                          contactLName: (this.state && this.state.contactLName) || "",
                          contactName: `${this.state?.contactFName || ""} ${this.state?.contactLName || ""}`.trim(),
                          clientId: parseInt(localStorage.getItem('userId')),
                          agentId: parseInt(localStorage.getItem('agentId')),
                         
                          organizationName: (this.state && this.state.organizationName) || "",
                          email: (this.state && this.state.email) || "",
                          phone: "",
                          mobile: "",
                         
                          fullAddress:'',
                          addressLine1:'',
                          addressLine2:'',
                          nearestIntersection:'',
                          city:'',
                          province:'',
                          postal:'',
                          country:'',
                          longitude:0,
                          latitude:0,   
                         
                        }}
                        validationSchema={Yup.object().shape({
                         
                          contactFName: Yup.string().required("This Field in required"),
                          contactLName: Yup.string().required("This Field in required"),
                          organizationName: Yup.string().required('This field is required'),
                          email: Yup.string().email('Invalid email').required('This Field in required'),
                          mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                          phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                        })}

                        onSubmit={this.handleSubmitLowyer}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>
                              
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="contactFName">
                                    {this.props.t("First Name *")}
                                  </Label>
                                  <Field
                                    name="contactFName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.contactFName && touched.contactFName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="contactFName"
                                  />
                                  <ErrorMessage
                                    name="contactFName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="contactLName">
                                    {this.props.t("Last Name *")}
                                  </Label>
                                  <Field
                                    name="contactLName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.contactLName && touched.contactLName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="contactLName"
                                  />
                                  <ErrorMessage
                                    name="contactLName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>

                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="organizationName">
                                    {this.props.t("Organization Name *")}
                                  </Label>
                                  <Field
                                    name="organizationName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.organizationName && touched.organizationName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="organizationName"
                                  />
                                  <ErrorMessage
                                    name="organizationName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="fullAddress">
                                            {this.props.t("Address")}
                                          </Label>


                                          <PlacesAutocomplete
                                             value={values.fullAddress}
                                             onChange={(value) => setFieldValue('fullAddress', value)}
                                            onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                          >
                                       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                    <input
                                                      {...getInputProps({
                                                        placeholder: 'Enter Address...',
                                                        className: 'form-control',
                                                      
                                                      })}
                                                    />
                                                    <div className="">
                                                      {loading ? <div>Loading...</div> : null}

                                                      {suggestions.map((suggestion, i) => {
                                                        const className = suggestion.active
                                                          ? 'suggestion-item--active'
                                                          : 'suggestion-item';
                                                        const style = suggestion.active
                                                          ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                          : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                        return (
                                                          <div
                                                          key={i}
                                                            {...getSuggestionItemProps(suggestion, {
                                                              style,
                                                            })}
                                                          >
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>


                                        </FormGroup>
                                      </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="email">
                                    {this.props.t("Email *")}
                                  </Label>
                                  <Field
                                    name="email"
                                    type="text"
                                    
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.email && touched.email
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="email"
                                  />
                                  <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                             
                              <Col md="3">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="mobile">
                                    {this.props.t("Mobile *")}
                                  </Label>
                                  <Field
                                    name="mobile"
                                    type="text"
                                   
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.mobile && touched.mobile
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="mobile"
                                  />
                                  <ErrorMessage
                                    name="mobile"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="3">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="phone">
                                    {this.props.t("Secondary Phone")}
                                  </Label>
                                  <Field
                                    name="phone"
                                    type="text"
                                   
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.phone && touched.phone
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="phone"
                                  />
                                  <ErrorMessage
                                    name="phone"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="2">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="phoneExt">
                                    {this.props.t("Ext")}
                                  </Label>
                                  <Field
                                    name="phoneExt"
                                    type="text"
                                    //value={values.phone}
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.phoneExt && touched.phoneExt
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="phoneExt"
                                  />
                                  <ErrorMessage
                                    name="phoneExt"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col> 
                          
                             
                             
                           
                             
                                 
                            
                            </Row>
                    
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="notes">
                                    {this.props.t("Notes ")}
                                  </Label>
                                  <Field
                                    name="notes"
                                    onChange={handleChange}
                                    as="textarea"

                                    className="form-control"

                                    id="notes"

                                  />
                                </FormGroup>
                              </Col>



                            </Row>






                            <div><button type="submit" className="btn btn-primary w-md float-end">Save</button></div>

                          </Form>
                        )}
                      </Formik>
                      </OffcanvasBody>
                    </Offcanvas>

                    <Offcanvas
                      isOpen={this.state.isRightAgent}
                      direction="end"
                      toggle={this.toggleRightCanvasAgent}
                      style={{width:800}}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvasAgent}>
                       My Mortgage Agent
                      </OffcanvasHeader>
                        <OffcanvasBody>
                        <Formik
                        enableReinitialize={true}
                        initialValues={{
                          dealId: 0,
                          professionalContactTypeId: 2,
                          contactFName: (this.state && this.state.contactFName) || "",
                          contactLName: (this.state && this.state.contactLName) || "",
                          contactName: `${this.state?.contactFName || ""} ${this.state?.contactLName || ""}`.trim(),
                          clientId: parseInt(localStorage.getItem('userId')),
                          agentId: parseInt(localStorage.getItem('agentId')),
                         
                          organizationName: (this.state && this.state.organizationName) || "",
                          email: (this.state && this.state.email) || "",
                          phone: "",
                          mobile: "",
                         
                          fullAddress:'',
                          addressLine1:'',
                          addressLine2:'',
                          nearestIntersection:'',
                          city:'',
                          province:'',
                          postal:'',
                          country:'',
                          longitude:0,
                          latitude:0,   
                         
                        }}
                        validationSchema={Yup.object().shape({
                         
                          contactFName: Yup.string().required("This Field in required"),
                          contactLName: Yup.string().required("This Field in required"),
                          organizationName: Yup.string().required('This field is required'),
                          email: Yup.string().email('Invalid email').required('This Field in required'),
                          mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                          phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                        })}

                        onSubmit={this.handleSubmitMortgage}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>
                              
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="contactFName">
                                    {this.props.t("First Name *")}
                                  </Label>
                                  <Field
                                    name="contactFName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.contactFName && touched.contactFName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="contactFName"
                                  />
                                  <ErrorMessage
                                    name="contactFName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="contactLName">
                                    {this.props.t("Last Name *")}
                                  </Label>
                                  <Field
                                    name="contactLName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.contactLName && touched.contactLName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="contactLName"
                                  />
                                  <ErrorMessage
                                    name="contactLName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>

                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="organizationName">
                                    {this.props.t("Organization Name *")}
                                  </Label>
                                  <Field
                                    name="organizationName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.organizationName && touched.organizationName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="organizationName"
                                  />
                                  <ErrorMessage
                                    name="organizationName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="fullAddress">
                                            {this.props.t("Address")}
                                          </Label>


                                          <PlacesAutocomplete
                                             value={values.fullAddress}
                                             onChange={(value) => setFieldValue('fullAddress', value)}
                                            onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                          >
                                       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                    <input
                                                      {...getInputProps({
                                                        placeholder: 'Enter Address...',
                                                        className: 'form-control',
                                                      
                                                      })}
                                                    />
                                                    <div className="">
                                                      {loading ? <div>Loading...</div> : null}

                                                      {suggestions.map((suggestion, i) => {
                                                        const className = suggestion.active
                                                          ? 'suggestion-item--active'
                                                          : 'suggestion-item';
                                                        const style = suggestion.active
                                                          ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                          : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                        return (
                                                          <div
                                                          key={i}
                                                            {...getSuggestionItemProps(suggestion, {
                                                              style,
                                                            })}
                                                          >
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>


                                        </FormGroup>
                                      </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="email">
                                    {this.props.t("Email *")}
                                  </Label>
                                  <Field
                                    name="email"
                                    type="text"
                                    
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.email && touched.email
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="email"
                                  />
                                  <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                             
                              <Col md="3">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="mobile">
                                    {this.props.t("Mobile *")}
                                  </Label>
                                  <Field
                                    name="mobile"
                                    type="text"
                                   
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.mobile && touched.mobile
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="mobile"
                                  />
                                  <ErrorMessage
                                    name="mobile"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="3">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="phone">
                                    {this.props.t("Secondary Phone")}
                                  </Label>
                                  <Field
                                    name="phone"
                                    type="text"
                                   
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.phone && touched.phone
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="phone"
                                  />
                                  <ErrorMessage
                                    name="phone"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="2">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="phoneExt">
                                    {this.props.t("Ext")}
                                  </Label>
                                  <Field
                                    name="phoneExt"
                                    type="text"
                                    //value={values.phone}
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.phoneExt && touched.phoneExt
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="phoneExt"
                                  />
                                  <ErrorMessage
                                    name="phoneExt"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col> 
                          
                             
                             
                           
                             
                                 
                            
                            </Row>
                    
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="notes">
                                    {this.props.t("Notes ")}
                                  </Label>
                                  <Field
                                    name="notes"
                                    onChange={handleChange}
                                    as="textarea"

                                    className="form-control"

                                    id="notes"

                                  />
                                </FormGroup>
                              </Col>



                            </Row>






                            <div><button type="submit" className="btn btn-primary w-md float-end">Save</button></div>

                          </Form>
                        )}
                      </Formik>
                        </OffcanvasBody>
                    </Offcanvas>

           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
MyLawyer.propTypes = {
  t: PropTypes.any

}
export default connect()(withTranslation()(MyLawyer))
